import { css as t } from "styled-components";
const e = {
  base: () => /* @__PURE__ */ t([
    "max-width:100%;width:255px;height:auto;"
  ])
};
export {
  e as default
};
